'use strict';

var Scene = require('./scene').Scene;

var BonusScene = function () {
    Scene.call(this);
};

BonusScene.prototype = Object.create(Scene.prototype);

BonusScene.prototype.constructor = BonusScene;

BonusScene.prototype.showFinishTable = function (stageMath, bet, done) {
    done();
};

BonusScene.prototype.selectionHasMade = function (variant) {
    throw new Error('should be overridden in derived class');
};

BonusScene.prototype.showResult = function (data, done) {
    throw new Error('should be overridden in derived class');
};


BonusScene.prototype.setOnUserSelect = function (func) {
    BonusScene.prototype.onUserSelect = func;
};


module.exports.BonusScene = BonusScene;



//////////////////
// WEBPACK FOOTER
// ./src/library/bonus_scene.js
// module id = 20
// module chunks = 0